/**
 * @fileoverview GET handler for the "/app_settings/custom_attribute_usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCustomAttributeUsage } from "./constants";
import type { AppSettingsCustomAttributeUsageResult } from "./types";
import { isAppSettingsCustomAttributeUsageResult } from "./validators";

export const getAppSettingsCustomAttributeUsage = reactQueryFetcherAdapter(
  appSettingsCustomAttributeUsage,
  (signal: AbortSignal): Promise<AppSettingsCustomAttributeUsageResult> => {
    return fetch("/app_settings/custom_attribute_usage", "GET", {}, { signal });
  },
  isAppSettingsCustomAttributeUsageResult
);
